import { useContext, useEffect } from "react"
import { Navigate, Outlet } from "react-router-dom"
import { UserContext } from "@context"
import { authService } from "@services"
import PropTypes from "prop-types"

/** what about reports look at client_settings */
const ProtectedRoutes = ({ admin = false, children, reports = false }) => {
  const { user } = useContext(UserContext)
  const isOrganiser = user?.clientUserRoles?.organiser || false

  useEffect(() => {
    if (user) {
      authService.setClarityUser(user)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  
  if (!user && window.location.pathname !== "/verify") {
    return <Navigate to="/session-expired" replace />
  }

  if (reports && !isOrganiser && user?.me?.client?.settings?.allow_teacher_reports !== true) {
    return <Navigate to="/404" replace />
  }

  if (admin && isOrganiser !== true) {
    return <Navigate to="/404" replace />    
  }

  return children ? children : <Outlet />
}

ProtectedRoutes.propTypes = {
  admin: PropTypes.bool,
  children: PropTypes.node,
  reports: PropTypes.bool,
}

export default ProtectedRoutes
